/* eslint-disable no-console */

import { register, unregister } from 'register-service-worker'

// if (process.env.NODE_ENV === 'production') {
    // register(`${process.env.BASE_URL}service-worker.js`, {
    //     registrationOptions: {},
    //     ready () {
    //         console.log(
    //             'App is being served from cache by a service worker.'
    //         )
    //     },
    //     registered (reg) {
    //         console.log(reg)
    //         reg.update();
    //         debugger
    //         console.log('Service worker has been registered.')
    //     },
    //     cached () {
    //         debugger
    //         console.log('Content has been cached for offline use.')
    //     },
    //     updatefound () {
    //         console.log('New content is downloading.')
    //     },
    //     updated () {
    //         console.log('New content is available; please refresh.')
    //     },
    //     offline () {
    //         debugger
    //         console.log('No internet connection found. App is running in offline mode.')
    //     },
    //     error (error) {
    //         debugger
    //         console.error('Error during service worker registration:', error)
    //     }
    // })
// }

unregister()
console.log('sw had unregister')
